<template>
	<component
		:is="thisComponent"
		:name="name"
		:options="options"
		:index="index"
		:type="type"
		:disabled="disabled"
		ref="component"
		@click="$emit('click', $event)"
		@change="$emit('change', $event)"
	></component>
</template>

<script>
import shared from '@/mixins/shared';
import Event from './elements/Event.vue';
import Checkbox from './elements/Checkbox.vue';
import Input from './elements/Input.vue';
import Label from './elements/Label.vue';
import Button from './elements/Button.vue';
import Radio from './elements/Radio.vue';
import Select from './elements/Select.vue';
import SearchSelect from './elements/SearchSelect.vue';
import Dates from './elements/Date.vue';
import DateCampaign from './elements/DateCampaign.vue';
import List from './elements/List.vue';
import Switch from './elements/Switch.vue';
import Address from './elements/Address.vue';
import ExtraInput from './elements/ExtraInput.vue';
import Placeholder from './elements/Placeholder.vue';
import Sum from './elements/Sum.vue';
import Phone from './elements/Phone.vue';
import Bank from './elements/Bank.vue';
import Chooser from './elements/Chooser.vue';
import Notifier from './Notifier';
import YesNoCheckbox from "@/components/elements/YesNoCheckbox.vue";

export default {
	mounted() {
		this.$nextTick(() => {
			if (this.$refs.component !== undefined) {
				if (typeof this.$refs.component.getData === 'function') {
					if (this.$refs.component.getData() !== null) {
						if (this.$refs.component.$refs.provider !== undefined) {
                            if(this.options?.noInitialValidation !== true) {
                                this.$refs.component.$refs.provider.validate();
                            }
						}
					}
				}
			}
		});
	},
	mixins: [shared],
	props: {
		name: { type: String, default: null },
		options: { type: Object, default: () => {} },
		index: { type: Number, default: null },
		disabled: { type: Boolean, default: false },
		type: { type: String, default: 'calculation' },
	},
	computed: {
		thisComponent() {
			return this.formComponents[this.options.type];
		},
	},
	data() {
		return {
			formComponents: {
				text: Input,
				event: Event,
				label: Label,
				button: Button,
				radio: Radio,
				select: Select,
				date: Dates,
				dateCampaign: DateCampaign,
				password: Input,
				email: Input,
				list: List,
				switch: Switch,
				extraInput: ExtraInput,
				placeholder: Placeholder,
				sum: Sum,
				checkbox: Checkbox,
                'yes-no-checkbox': YesNoCheckbox,
				address: Address,
				searchSelect: SearchSelect,
				phone: Phone,
				bank: Bank,
				chooser: Chooser,
				notifier: Notifier,
			},
		};
	},
};
</script>
